import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function requestCastUrl(cast_key, kasm_url, docker_network, recaptcha_value, referrer){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {'cast_key': cast_key, 'recaptcha_value': recaptcha_value, 'referrer': referrer, 'kasm_url': kasm_url, 'docker_network' : docker_network, 'x_res': window.innerWidth, 'y_res': window.innerHeight};
    appendTokenName(data);
    return apiAction({
        types: ["REQUEST_CAST_REQUESTED", "REQUEST_CAST_SUCCESS", "REQUEST_CAST_FAILED"],
        method: "POST",
        path: "request_cast",
        body: data
    });
}

export function getCastConfigs(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_CAST_REQUESTED", "GET_CAST_SUCCESS", "GET_CAST_FAILED"],
        method: "POST",
        path: "admin/get_cast_configs",
        body: data
    });
}

export function setCastPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_CAST_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function deleteCastConfig(cast_config_id){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {cast_config_id: cast_config_id};
    appendTokenName(data);
    return apiAction({
        types: ["DELETE_CAST_REQUESTED", "DELETE_CAST_SUCCESS", "DELETE_CAST_FAILED"],
        method: "POST",
        path: "admin/delete_cast_config",
        body: data
    });
}

export function createCastConfig(cast_config){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_cast_config = cast_config;
    appendTokenName(data);
    return apiAction({
        types: ["CREATE_CAST_REQUESTED", "CREATE_CAST_SUCCESS", "CREATE_CAST_FAILED"],
        method: "POST",
        path: "admin/create_cast_config",
        body: data
    });
}

export function updateCastConfig(cast_config){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_cast_config = cast_config;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_CAST_REQUESTED", "UPDATE_CAST_SUCCESS", "UPDATE_CAST_FAILED"],
        method: "POST",
        path: "admin/update_cast_config",
        body: data
    });
}



// WEBPACK FOOTER //
// ./src/actions/actionCast.js